import { useAuth } from '@auth/useAuth'
import { getTenant, Tenant } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'

/**
 * Get the Tenant entity and associated info for the currently authenticated tenant.
 * Note: If you just need to know if the user is authenticated, use the `useAuth` hook
 * instead.
 *
 * @returns Tuple of the Tenant & loaded status
 */
export const useCurrentTenant = (): [Tenant | null, boolean] => {
  const { tenantId } = useAuth()
  const { data: tenant, isSuccess } = useQuery<Tenant>({
    queryKey: ['useCurrentTenant', tenantId],
    queryFn: () => getTenant(tenantId ?? ''),
    enabled: Boolean(tenantId),
    staleTime: 5 * 60 * 1000,
  })
  if (!tenantId) return [null, true]
  return [tenant || null, isSuccess]
}
